import React from 'react';
import { p } from '@upgrade/react-components/Spacing/core';
import cn from 'classnames';
import styled from 'styled-components';

const StyledFluid = styled.div`
  position: relative;
  ${({ padding = 'md' }) => p(padding)};
`;

const Fluid = ({ children, className, padding }) => (
  <StyledFluid className={cn('container-fluid', 'layout-default', className)} padding={padding}>
    {children}
  </StyledFluid>
);

export default Fluid;
